import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import UsageTracker from '../../../utils/UsageTracker';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import { CardMenuIcon } from '../../../features/cardMenu';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import InstructorList from '../../../components/InstructorList';
import { OverviewContent, OverviewModalDescriptionSection, useOverviewNavigation } from '../../../features/overview';
import { mapShortProfessorToProfessor, useShort, useShortContentParams, useShortStatus, useStartShort } from '../../shortContent';
import { ShortCardTimeReadout } from '../../cards';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ShortOverviewModal = ({
  shortId: shortIdFromProps,
  language: languageFromProps,
  allowFullWidthChildren,
  playlistId
}) => {
  const {
    source
  } = useParams();
  const {
    shortId: shortIdFromParams,
    language: languageFromParams
  } = useShortContentParams();
  const shortId = shortIdFromProps || Number(shortIdFromParams);
  const [[searchParamLanguage]] = useSearchParam(FILTER_TYPES.LANGUAGE);
  const {
    goTo
  } = useOverviewNavigation();
  const language = languageFromProps || languageFromParams || searchParamLanguage;
  const {
    short,
    shortLoading: loading,
    shortError: error
  } = useShort(shortId, language);
  const {
    status
  } = useShortStatus(shortId, language);
  const [startShort] = useStartShort(shortId, language, playlistId);
  const professors = useMemo(() => {
    if (!short) return [];
    return short.professors.map(mapShortProfessorToProfessor(language));
  }, [language, short]);
  const handleChangeSelectedLanguage = ({
    target: {
      value
    }
  }) => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-change-language',
      appearsIn: source,
      trackId: shortId,
      name: short ? short.name : null,
      previousLanguage: language,
      newLanguage: value
    });
    goTo({
      id: shortId,
      type: 'SHORT_FORM_CONTENT',
      language: value
    });
  };
  const handleEnroll = () => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-enroll',
      appearsIn: source,
      contentLanguage: language,
      contentType: 'SHORT',
      shortId,
      name: short ? short.name : null
    });
  };
  const handleOrganisationUrlClick = (professorId, organisation, organisationUrl) => () => {
    UsageTracker.track('interaction', {
      action: 'professor-organisation-click',
      contentType: 'SHORT',
      appearsIn: 'short-overview-curriculum',
      organisation,
      organisationUrl,
      professorId,
      shortId
    });
  };
  const handleOnVideoProgress = () => {
    if (status !== 'COMPLETED') {
      startShort().catch(Raven.captureException);
    }
  };
  return /*#__PURE__*/_jsxs(OverviewContent, {
    allowFullWidthChildren: allowFullWidthChildren,
    assetLanguage: language,
    autoplay: false,
    error: error,
    fallbackThumbnailUrl: short && short.previewThumbnailRectangleUrl,
    headerIcons: /*#__PURE__*/_jsx(CardMenuIcon, {
      language: language,
      shortId: shortId,
      use: "on-dark"
    }),
    loading: loading,
    onVideoProgress: handleOnVideoProgress,
    shortId: shortId,
    children: [/*#__PURE__*/_jsx(OverviewModalDescriptionSection, {
      availableLanguages: short && short.languages,
      availableLanguagesLoading: loading,
      description: short && short.description,
      duration: short && /*#__PURE__*/_jsx(ShortCardTimeReadout, {
        language: language,
        shortId: shortId
      }),
      id: shortId,
      onChangeSelectedLanguage: handleChangeSelectedLanguage,
      onEnroll: handleEnroll,
      selectedLanguage: language,
      title: short && short.name,
      type: "SHORT_FORM_CONTENT"
    }), !!professors.length && /*#__PURE__*/_jsx(InstructorList, {
      handleOrganisationUrlClick: handleOrganisationUrlClick,
      language: language,
      professors: professors
    })]
  });
};
export default ShortOverviewModal;